import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepTwoExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepTwoExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.discoverStepTwoExtraLevels.data.discoverStepTwoExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
